import request from "@/utils/request";
const projectName = "/api/blade-platform";
export const getAppStartImage = params => {
    return request({
        url: `${projectName}/appconfiguration/getAppStartImage`,
        method: "post",
        data: params
    });
};
export const deleteStartImage = params => {
    return request({
        url: `${projectName}/appconfiguration/deleteStartImage`,
        method: "post",
        data: params
    });
};
export const saveAppStartImage = params => {
    return request({
        url: `${projectName}/appconfiguration/saveAppStartImage`,
        method: "post",
        data: params
    });
};
